import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { AccountService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { HttpCommonService } from "projects/sepidz-web-framework/src/lib/services/http-common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ReviewService } from "src/app/review/review.service";

@Component({
  selector: "ngx-costs-spent-review",
  templateUrl: "./costs-spent-review.component.html",
  styleUrls: ["./costs-spent-review.component.scss"],
})
export class CostsSpentReviewComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  formGroup: UntypedFormGroup;
  activeTabTitle: string;
  BranchIds: number[] = [];
  CostsCategoryIds: number[] = [];
  CostsIds: number[] = [];
  hasPermission: boolean = false;
  IncludeDeletedFactors: boolean = false;
  GetCostsSpentListColumns: form_control[] = [];
  GetTotalCostsListByDateColumns: form_control[] = [];
  GetCostsCategoryListColumns: form_control[] = [];
  GetCostsListColumns: form_control[] = [];
  selected: string = "";
  public isMultiBranch =
    (this.accountService.authService.currentInformation().BranchingAdvancedEnabled ||
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().RestaurantCallCenter) &&
    this.accountService.authService.currentBranch?.AccessToAllBranches;
  constructor(
    private service: ReviewService,
    private fb: UntypedFormBuilder,
    private accountService: AccountService,
    private translate: TranslateService,
    private httpCommonService: HttpCommonService,
    private sts: ShowToastrService,
    public tabsservice: TabularService
  ) {
    if (this.accountService.authService.currentInformation().BranchingLightEnabled) {
      this.sts.showDialog(
        this.translate.instant("ClientApp.FrontOffice.Review.CostsSpentReview.AccessExpenseReportMenuNotAllowedLiteLicense"),
        this.translate.instant("ClientApp.FrontOffice.Review.CostsSpentReview.Error")
      );
      this.hasPermission = false;
      const costGroupTab = this.tabsservice.tabItemSubject?.value?.findIndex((x) => x.title == "ClientApp.Pages.PageMenu.CostGroup");
      this.tabsservice.close(costGroupTab);
    } else this.hasPermission = true;
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.BranchIds = undefined;
    this.CostsCategoryIds = undefined;
    this.CostsIds = undefined;
  }

  ngOnInit(): void {
    this.service.startDate = new Date();
    this.service.endDate = new Date();
    this.service.ReportKey = "CostsSpentReview";
    this.service.startDate$.next(this.service.startDate);
    this.service.endDate$.next(this.service.endDate);
    this.formGroup = this.fb.group({
      BranchIds: this.BranchIds,
      CostsCategoryIds: this.CostsCategoryIds,
      CostsIds: this.CostsIds,
    });
  }
  selectTab($event) {
    this.setColumns($event.tabTitle);
    this.activeTabTitle = $event.tabTitle;
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  setColumns(activeTabTitle: string) {
    switch (activeTabTitle) {
      case this.translate.instant("ClientApp.FrontOffice.Review.CostsSpentReview.CostsSpent"):
        if (!this.GetCostsSpentListColumns || this.GetCostsSpentListColumns?.length <= 0) {
          this.httpCommonService
            .get("CostsSpentReview/GetCostsSpentColumns")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetCostsSpentListColumns = data as form_control[];
                  this.GetCostsSpentListColumns = this.GetCostsSpentListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CostsSpentReview.TotalCostsByDate"):
        if (!this.GetTotalCostsListByDateColumns || this.GetTotalCostsListByDateColumns?.length <= 0) {
          this.httpCommonService
            .get("CostsSpentReview/GetTotalCostsByDateColumns")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetTotalCostsListByDateColumns = data as form_control[];
                  this.GetTotalCostsListByDateColumns = this.GetTotalCostsListByDateColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CostsSpentReview.CostsCategory"):
        if (!this.GetCostsCategoryListColumns || this.GetCostsCategoryListColumns?.length <= 0) {
          this.httpCommonService
            .get("CostsSpentReview/GetCostsCategoryColumns")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetCostsCategoryListColumns = data as form_control[];
                  this.GetCostsCategoryListColumns = this.GetCostsCategoryListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.CostsSpentReview.Costs"):
        if (!this.GetCostsListColumns || this.GetCostsListColumns?.length <= 0) {
          this.httpCommonService
            .get("CostsSpentReview/GetCostsColumns")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetCostsListColumns = data as form_control[];
                  this.GetCostsListColumns = this.GetCostsListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      default:
        break;
    }
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
